// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

export function Title(): Node {
  return (
    <Header>
      <TitleText />
    </Header>
  );
}

const Header = styled.h1`
  font-size: 22px;
  font-family: "Gilroy", "Open Sans", "OpenSans", Arial, "Helvetica Neue", Helvetica,sans-serif;
  color: #2397d4;
  margin-bottom: 16px;
`;

function TitleText(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'mx':
      return 'Falta poco para finalizar tu compra.';

    default:
      throw new Error('Not implemented yet');
  }
}
